module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//2.jpg?58a86fc96ce1a7809498fb496a7e0d12";